<template>
  <div class="row justify-center full-width">
    <div class="desktop-single-column row items-center full-width">
      <div class="q-px-md q-py-xl full-width">
        <div
          class="thank-you-card bdr-a-grey-3 bg-white row justify-center q-py-xl q-px-md"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThankYouLayout'
};
</script>

<style lang="sass" scoped>
.thank-you-card
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05)
</style>
